<script>
export default {
    computed: {
        emailStats() {
            return this.$store.getters.EMAIL_STATS;
        },
        emailMode() {
            return this.$store.getters.EMAIL_MODE;
        },
    },
    methods: {
        async clearEmails() {
            this.$store.commit('SHOP_POPUP_NAME', 'confirmed');
            this.$store.commit(
                'CONFIRMED_POPUP_METHOD',
                this.confirmClearEmails.bind(this)
            );
        },
        async confirmClearEmails() {
            const success = await this.$store.dispatch('CLEAR_SENT_EMAILS');
            if (success) {
                this.$store.commit('POPUP_ADD', {
                    title: 'EMAILS CLEARED',
                    description: ['All test emails have been cleared'],
                    color: '#00d25b',
                });
                // Refresh emails after clearing
                await this.refreshEmails();
            }
        },
        async refreshEmails() {
            await this.$store.dispatch('LOAD_SENT_EMAILS');
            await this.$store.dispatch('LOAD_EMAIL_STATS');
        },
    },
};
</script>

<template>
    <div class="page_header">
        <h1>Test Emails</h1>
        <div class="email_mode_info" v-if="emailMode">
            <span class="mode_badge">{{ emailMode.mode }}</span>
            <span class="mode_description">{{ emailMode.description }}</span>
        </div>

        <div class="header_actions">
            <button class="button_blue_100" @click="refreshEmails">
                Refresh
            </button>
            <button
                class="button_blue_100 button_red ml_10"
                @click="clearEmails"
            >
                Clear All
            </button>
        </div>

        <div class="email_stats" v-if="emailStats">
            <div class="stat_item">
                <span class="stat_label">Total Emails:</span>
                <span class="stat_value">{{ emailStats.total_emails }}</span>
            </div>
            <div class="stat_item">
                <span class="stat_label">Unique Recipients:</span>
                <span class="stat_value">{{
                    emailStats.unique_recipients
                }}</span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.page_header {
    padding: 20px;
    border-bottom: 1px solid var(--border-color);
}

.email_mode_info {
    margin: 10px 0;
}

.mode_badge {
    background-color: var(--main-color);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    text-transform: uppercase;
}

.header_actions {
    margin: 15px 0;
}

.email_stats {
    display: flex;
    gap: 20px;
    margin-top: 15px;
}

.stat_item {
    display: flex;
    flex-direction: column;
}

.stat_label {
    font-size: 12px;
    color: var(--text-color-secondary);
}

.stat_value {
    font-size: 18px;
    font-weight: bold;
    color: var(--main-color);
}
</style>
